module.exports = __webpack_public_path__ + "img/logo.435f268c.png";